var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSearch(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9081 5.03076H7.75422C5.97568 5.03076 4.53418 6.47226 4.53418 8.2508V14.6909H53.9081V5.03076Z",
    fill: "#E2D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9079 3.22004C53.9079 1.4415 52.4663 0 50.6878 0C46.1486 0 37.9655 0 33.8588 0C32.3186 0 30.8953 0.825402 30.1311 2.16279C28.8635 4.38247 27.0742 7.51342 27.0742 7.51342H53.9079V3.22004Z",
    fill: "#E2D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53418 8.04794H53.9081V10.0476H4.53418V8.04794Z",
    fill: "#AA7CFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5226 14.2444C57.6933 13.0143 57.323 11.7703 56.5083 10.8343C55.6926 9.8973 54.5119 9.35956 53.27 9.35956C42.3262 9.35956 16.1151 9.35956 5.17129 9.35956C3.92943 9.35956 2.74875 9.8973 1.93301 10.8343C1.11834 11.7703 0.748035 13.0143 0.918697 14.2444C2.00707 22.0798 4.11941 37.2869 5.09294 44.298C5.38811 46.42 7.20206 48 9.34553 48H49.0958C51.2393 48 53.0532 46.42 53.3484 44.298C54.3219 37.2869 56.4343 22.0798 57.5226 14.2444Z",
    fill: "#E2D5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27934 16.8418C1.35984 15.9477 1.71834 15.0934 2.31834 14.4043C3.13301 13.4683 4.31369 12.9306 5.55555 12.9306H52.8858C54.1276 12.9306 55.3083 13.4683 56.123 14.4043C56.723 15.0934 57.0815 15.9477 57.162 16.8418L57.5226 14.2443C57.6933 13.0143 57.323 11.7703 56.5083 10.8343C55.6926 9.8973 54.5119 9.35956 53.27 9.35956C42.3262 9.35956 16.1151 9.35956 5.17129 9.35956C3.92943 9.35956 2.74875 9.8973 1.93301 10.8343C1.11834 11.7703 0.748035 13.0143 0.918697 14.2443L1.27934 16.8418Z",
    fill: "#EFE9FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3919 37.2945C24.3919 36.1095 23.4312 35.1478 22.2452 35.1478C19.8634 35.1478 16.0412 35.1478 13.6584 35.1478C12.4734 35.1478 11.5117 36.1095 11.5117 37.2945V39.4411C11.5117 40.6272 12.4734 41.5878 13.6584 41.5878H22.2452C23.4312 41.5878 24.3919 40.6272 24.3919 39.4411C24.3919 38.751 24.3919 37.9857 24.3919 37.2945Z",
    fill: "#9B5AF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4908 17.1306C34.2708 17.1306 29.2207 22.1807 29.2207 28.4007C29.2207 34.6208 34.2708 39.6709 40.4908 39.6709C46.7109 39.6709 51.761 34.6208 51.761 28.4007C51.761 22.1807 46.7109 17.1306 40.4908 17.1306ZM40.4908 20.3507C44.9334 20.3507 48.5409 23.9582 48.5409 28.4007C48.5409 32.8433 44.9334 36.4508 40.4908 36.4508C36.0483 36.4508 32.4407 32.8433 32.4407 28.4007C32.4407 23.9582 36.0483 20.3507 40.4908 20.3507Z",
    fill: "#9B5AF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3606 36.1835L56.3727 46.1957C57.0017 46.8247 58.0214 46.8247 58.6504 46.1957C59.2783 45.5678 59.2783 44.547 58.6504 43.9191L48.6382 33.907C48.0092 33.2791 46.9896 33.2791 46.3606 33.907C45.7327 34.5349 45.7327 35.5556 46.3606 36.1835Z",
    fill: "#9B5AF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSearch);
export default __webpack_public_path__ + "static/media/FileSearch.2f5034efe94abce6c1aff8376a14dd4a.svg";
export { ForwardRef as ReactComponent };